import React, { useEffect, useState } from "react";
import { Checkbox, TextField, Select, MenuItem } from "@mui/material";
import {
  Button,
  CardContainer,
  InputContainer,
  Title,
  Divider,
  SubTitle,
} from "./styles";

import Snackbar from "../../components/Snackbar";
import { Box } from "@mui/system";
import { useUser } from "../../contexts/UserContext";
import Translator from "../../components/i18nComponents/Translator";
import { useTranslation } from "react-i18next";

export default function FollowConfig( {trader, enableAdvance} ) {

  const {t} = useTranslation()

  const [enable, setEnable] = useState(trader.traderEna);
  const [acptdemo, setAcptDemo] = useState(trader.acptdemo);
  const [traderID, setTraderID] = useState(trader.traderID);
  const [maxTrades, setMaxTrades] = useState(trader.maxTrades);
  const [minStake, setMinStake] = useState(trader.minStake);
  const [maxStake, setMaxStake] = useState(trader.maxStake);
  const [lote, setLote] = useState(trader.lote);
  const [signalType, setSignalType] = useState(trader.signalType);
  const [delaySig, setDelaySig] = useState(trader.delaysig);
  const [brokerID, setBrokerID] = useState(trader.brokerID);
  const [loteType, setLoteType] = useState(trader.loteType);
  //
  const [saveStateOpen, setSaveStateOpen] = useState(false);

  const { handleSaveTraderInfo, handleRemoveTrader } = useUser();

  const handleSignal = (event) => {
    setSignalType(event.target.value);
  };

  const handleBrokerID = (event) => {
    setBrokerID(event.target.value);
  };

  const handleSave = async (btn) => {
    if (btn === 1) {
      //
      await handleSaveTraderInfo({
        traderEna: enable,
        traderID: traderID,
        maxTrades: maxTrades,
        signalType: signalType,
        delaysig: delaySig,
        brokerID: brokerID,
        minStake: minStake,
        maxStake: maxStake,
        lote: lote,
        acptdemo: acptdemo,
        loteType: loteType,
      });
      //
      setSaveStateOpen((prevState) => !prevState);
    } else {
      //
      handleRemoveTrader(traderID);
      setSaveStateOpen((prevState) => !prevState);
      //window.location.reload();
    }
  };

  return (
    
    <CardContainer>

      <SubTitle>ID: {traderID}</SubTitle>

      <InputContainer>
        <Checkbox
          checked={enable}
          name={"chanEnable"}
          id={"idEn"}
          onChange={() => setEnable(!enable)}
        />
        <div>{t("componentes.ChannelCardComponente.textCheckox")}</div>
      </InputContainer>

      <InputContainer>
        <Checkbox
          checked={acptdemo}
          name={"acptDemo"}
          onChange={() => setAcptDemo(!acptdemo)}
        />
        <div>{t("componentes.ChannelCardComponente.accDemoCheckox")}</div>
      </InputContainer>

      <Select
          labelId="demo-select-small"
          value={loteType}
          label={t('paginas.copyTrader.LoteType')}
          defaultValue={1}
          onChange={(e) => setLoteType(e.target.value)}
          required
        >
          <MenuItem value={1}><Translator path="paginas.copyTrader.LoteType1"/></MenuItem>
          <MenuItem value={2}><Translator path="paginas.copyTrader.LoteType2"/></MenuItem>
        </Select>

      <Box
        component="form"
        sx={{
          maxWidth: "100%",
        }}
        noValidate
        autoComplete="off"
      >

        <TextField
          fullWidth
          sx={{ marginBottom: "15px" }}
          id="idLote"
          name="lote"
          label={t('componentes.ChannelCardComponente.TextFieldEntrada')}
          type="number"
          defaultValue={lote}
          onChange={(e) => {
            setLote(e.target.value);
          }}
          variant="filled"
        />

        <TextField
          fullWidth
          sx={{ marginBottom: "15px" }}
          id="idMaxTrades"
          name="maxTrades"
          label="Limite de ordens"
          type="number"
          defaultValue={maxTrades}
          onChange={(e) => setMaxTrades(e.target.value)}
          variant="filled"
        />

        { enableAdvance && (
        <TextField
          fullWidth
          sx={{ marginBottom: "15px" }}
          label="Valor minimo"
          type="number"
          defaultValue={minStake}
          onChange={(e) => setMinStake(e.target.value)}
          variant="filled"
        />
        )}

        { enableAdvance && (
        <TextField
          fullWidth
          sx={{ marginBottom: "15px" }}
          label="Valor máximo"
          type="number"
          defaultValue={maxStake}
          onChange={(e) => setMaxStake(e.target.value)}
          variant="filled"
        />
        )}

      { enableAdvance && (
      <TextField
          fullWidth
          sx={{ marginBottom: "15px" }}
          id="idDelay"
          name="delaysig"
          label="Delay: "
          type="number"
          defaultValue={delaySig}
          onChange={(e) => setDelaySig(e.target.value)}
          variant="filled"
        />
        )}

      </Box>

      <Select
          labelId="demo-select-small"
          value={signalType}
          label={t('componentes.ChannelCardComponente.SelectSinalTipo.labelSinalTipo')}
          defaultValue={7}
          onChange={handleSignal}
          required
        >
          <MenuItem value={7}><Translator path="componentes.ChannelCardComponente.SelectSinalTipo.MenuItens.MenuItem7"/></MenuItem>
          <MenuItem value={8}><Translator path="componentes.ChannelCardComponente.SelectSinalTipo.MenuItens.MenuItem8"/></MenuItem>
        </Select>

      { enableAdvance && (
      <Select
          labelId="demo-select-small"
          value={brokerID}
          label={t('componentes.ChannelCardComponente.SelectCorretora.labelCorretora')}
          defaultValue={0}
          onChange={handleBrokerID}
          required
        >
          <MenuItem value={0}><Translator path="componentes.ChannelCardComponente.SelectCorretora.MenuItens.MenuItem1"/></MenuItem>
          <MenuItem value={1}>IQ</MenuItem>
          <MenuItem value={2}>Deriv</MenuItem>
          <MenuItem value={3}>DayProfit</MenuItem>
          <MenuItem value={4}>CapitalBear</MenuItem>
          <MenuItem value={5}>Quotex</MenuItem>
          <MenuItem value={6}>Pocket</MenuItem>
          <MenuItem value={7}>Avalon</MenuItem>
          <MenuItem value={8}>Exnova</MenuItem>
          <MenuItem value={9}>Binomo</MenuItem>
          <MenuItem value={10}>Stockity</MenuItem>
          <MenuItem value={11}>Binolla</MenuItem>
          <MenuItem value={12}>Olymp 1</MenuItem>
          <MenuItem value={14}>Bullex</MenuItem>
          <MenuItem value={15}>Optinary</MenuItem>
          <MenuItem value={16}>Broker10</MenuItem>
          <MenuItem value={17}>Pixtrade</MenuItem>
          <MenuItem value={18}>Optgo</MenuItem>
        </Select>
      )}

      <Snackbar
        type="success"
        open={saveStateOpen}
        onClose={() => setSaveStateOpen(false)}
      >
        <Translator path="componentes.ChannelCardComponente.TextoSalvo"/>
      </Snackbar>

      <Button onClick={() => handleSave(1)}><Translator path="buttonSalvar"/></Button>
      <Button onClick={() => handleSave(2)}><Translator path="componentes.ChannelCardComponente.ButtonRemover"/></Button>
    
    </CardContainer>
  );
}
